import * as React from 'react';
import styled from 'styled-components';
import { ALIGN, COLOR, DISPLAY, FONT_FAMILY, FONT_SIZE, FONT_WEIGHT, LINE_HEIGHT, TEXT_VARIANT, MARGIN } from '@latitude/core/utils/constants';
import { getLineHeight } from './Text.helpers';
var StyledText = /*#__PURE__*/styled.div.withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-14zwpg7-0"
})(["margin:", " 0 ", ";padding:0;display:", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";text-align:", ";color:", ";"], function (_ref) {
  var marginTop = _ref.marginTop;
  return marginTop;
}, function (_ref2) {
  var marginBottom = _ref2.marginBottom;
  return marginBottom;
}, function (_ref3) {
  var cssDisplay = _ref3.cssDisplay;
  return cssDisplay;
}, FONT_FAMILY.BODY, function (_ref4) {
  var cssFontSize = _ref4.cssFontSize;
  return cssFontSize;
}, function (_ref5) {
  var cssFontWeight = _ref5.cssFontWeight;
  return cssFontWeight;
}, function (_ref6) {
  var cssLineHeight = _ref6.cssLineHeight;
  return cssLineHeight;
}, function (_ref7) {
  var cssTextAlign = _ref7.cssTextAlign;
  return cssTextAlign;
}, function (_ref8) {
  var cssColor = _ref8.cssColor;
  return cssColor;
});

var Text = function Text(_ref9) {
  var id = _ref9.id,
      className = _ref9.className,
      children = _ref9.children,
      marginBottom = _ref9.marginBottom,
      marginTop = _ref9.marginTop,
      _ref9$align = _ref9.align,
      align = _ref9$align === void 0 ? ALIGN.LEFT : _ref9$align,
      _ref9$color = _ref9.color,
      color = _ref9$color === void 0 ? COLOR.BODY : _ref9$color,
      _ref9$display = _ref9.display,
      display = _ref9$display === void 0 ? DISPLAY.BLOCK : _ref9$display,
      _ref9$fontSize = _ref9.fontSize,
      fontSize = _ref9$fontSize === void 0 ? FONT_SIZE.NORMAL : _ref9$fontSize,
      _ref9$fontWeight = _ref9.fontWeight,
      fontWeight = _ref9$fontWeight === void 0 ? FONT_WEIGHT.LIGHT : _ref9$fontWeight,
      _ref9$lineHeight = _ref9.lineHeight,
      lineHeight = _ref9$lineHeight === void 0 ? LINE_HEIGHT.STANDARD : _ref9$lineHeight,
      _ref9$variant = _ref9.variant,
      variant = _ref9$variant === void 0 ? TEXT_VARIANT.P : _ref9$variant;
  var props = {
    id: id,
    className: className,
    children: children,
    marginBottom: marginBottom,
    marginTop: marginTop,
    cssColor: color,
    cssDisplay: display,
    cssFontSize: fontSize,
    cssFontWeight: fontWeight,
    cssLineHeight: getLineHeight(lineHeight, fontSize),
    cssTextAlign: align,
    variant: variant
  };
  return /*#__PURE__*/React.createElement(StyledText, Object.assign({
    as: variant
  }, props), children);
};

export default Text;